<template>
  <div>
    <HistoryBaseDesign
      :pageTitle="pageTitle"
      :searchHeaderInfo="searchHeaderInfo"
      @changeInvalid="ini()"
      @changeProductName="ini()"
    >
      <template #searchDetailArea>
        <div class="px-9 py-7 d-flex">
          <div style="width: 440px">
            <InputFormNew
              v-model="searchDetailInfo.line1"
              :detail="searchDetail.line1"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
            </InputFormNew>
          </div>
          <div style="width: 440px" class="mt-12 ml-4">
            <InputFormNew
              v-model="searchDetailInfo.line2"
              :detail="searchDetail.line2"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
            </InputFormNew>
          </div>
        </div>
      </template>
      <template #historyList>
        <HistoryList
          :summary="summary"
          :historyList="historyList"
          :headers="headers"
          :itemKey="tableKey"
          :productListHeaders="productListHeaders"
          :isOperation="true"
          :isFooter="true"
          @rowDialogMethodCommon="rowDialogMethodCommon"
        >
        </HistoryList>
      </template>
    </HistoryBaseDesign>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { commonUtil, customerUtil, currencyUtil } from '@/util'

import { saleStatusHistory } from '@/config'

import detail from './detail'
import headers from './headers'

import InputFormNew from '@/components/items/Designs/InputFormNew'
import { HistoryBaseDesign, HistoryList } from '@/components/layouts'

export default {
  components: {
    HistoryBaseDesign,
    HistoryList,
    InputFormNew
  },
  data: () => {
    return {
      pageTitle: 'sale.sale_refund-history',

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 2,
        contentsCols: 12 - 2,
        inputItemHeight: '32px'
      },

      searchDetail: detail.detail,

      headers: headers.headers,
      tableKey: headers.tableKey,
      productListHeaders: headers.productListHeaders,

      searchHeaderInfo: {
        productName: '',
        InvalidData: true,
        checkboxLabel: 'refund.refund_not-show-invalid-refunds'
      },
      searchDetailInfo: {
        line1: {
          customerName: [],
          refundDate: { start: '', end: '' },
          status: {},
          storage: {}
        },
        line2: {
          saleInfo: {},
          productInfo: {
            number: '',
            category: ''
          }
        }
      },

      summary: {},
      historyList: [],
      customerList: [],

      dialogs: {
        ship: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        },
        salesDetail: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        }
      }
    }
  },
  async created() {
    this.ini()
  },
  methods: {
    ...mapActions('Refund', ['getRefundListFromApi']),
    ...mapGetters('Refund', ['getRefundListFromState']),

    async ini() {
      customerUtil.getCustomer() // CU01_顧客一覧取得

      const getList = await this.getHistoryFromApi()
      const isNoData = !Object.keys(getList).length

      this.historyList = isNoData
        ? []
        : getList
            .sort((a, b) => {
              const keyName = 'refundId'
              if (a[keyName] < b[keyName]) return 1
              if (a[keyName] > b[keyName]) return -1
              return 0
            })
            .map((ele, Index) => {
              ele.panelIndex = Index + 1
              // ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
              return ele
            })
    },

    formatObjectRequest(val) {
      return this.isObject(val) ? val.value : val
    },
    async getHistoryFromApi() {
      const line1 = this.searchDetailInfo.line1
      const line2 = this.searchDetailInfo.line2

      // API call
      const ret = await this.getRefundListFromApi({
        invalidRefundDisplay: this.searchHeaderInfo.InvalidData ? 0 : 1,

        // refundDate
        refundStartDate: commonUtil.nullEmptyFormatNull(line1.refundDate.start),
        refundEndDate: commonUtil.nullEmptyFormatNull(line1.refundDate.end),
        // storage
        loadingStorageId: commonUtil.nullEmptyFormatNull(line1.storage.value),

        status: commonUtil.nullEmptyFormatNull(line1.status?.value),

        customerIds: commonUtil.nullEmptyFormatNull(
          line1.customerName
            .map((customerName) => {
              return customerName.value
            })
            .join(',')
        ),
        productNumber: commonUtil.nullEmptyFormatNull(line2.productInfo.number),
        productCategoryId: commonUtil.nullEmptyFormatNull(
          line2.productInfo.category
        ),
        saleControlNumber: commonUtil.nullEmptyFormatNull(
          line2.saleInfo.saleNumber
        ),
        searchKey: commonUtil.nullEmptyFormatNull(
          line2.saleInfo.remittanceNumber
        ),
        productName: commonUtil.nullEmptyFormatNull(
          this.searchHeaderInfo.productName
        )
        // page: 1
      })

      const getList = this.getRefundListFromState()

      return getList
    },
    isObject(val) {
      return val && typeof val === 'object'
    },

    getBeforeCompleteFlgTmp(rec) {
      return rec.status == 1 && !rec.compDate
    },

    rowDialogMethodCommon(...args) {
      this.ini()
    }
  },
  watch: {
    searchDetailInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.ini()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.inputFormStyle {
  &::v-deep {
    .MultipleSelectCustomerName {
      width: 822px;
    }
  }
}
</style>
